import { Layout } from "@/components/layout/Layout";
import { getStrapiEntity } from "@/utils/strapi";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { routes } from "@/routes/routes";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layout = await getStrapiEntity<Layout>("layout", "");
  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      intlMessages,
      defaultCanonicalRoute: routes.checkIn,
    },
    revalidate: 10,
  };
};

export { Rental as default } from "@/components/pages/checkIn/rental/Rental";
